/** The prompts under the chat box, here and on Home. */
export const CAPABILITY_PROMPTS = [
  {
    label: "Build me a dashboard",
    prompt:
      "I want to create a dashboard. Ask me what it should cover, then explore the schema and stream widgets into the preview.",
  },
  {
    label: "Summarize recent data",
    prompt:
      "Summarize recent robot data collection volume and quality. Call out notable operators, days, or quality patterns.",
  },
  {
    label: "Find weak spots",
    prompt:
      "Analyze recent robot episodes and tell me where data quality, task ratings, or collection coverage look weakest.",
  },
  {
    label: "Show episodes",
    prompt:
      "Help me find relevant episodes. Ask what filters I want, then confirm before changing the page or applying filters.",
  },
];
